export default "__VITE_ASSET__DIf7rr30__"